export default __webpack_public_path__ + "static/kz-79601a42eadf5e44c19ebf5ab63edd47.svg";